/* eslint-disable no-unused-vars */

import React, { useContext } from 'react';
import {
  DefaultLocale,
  ErrorContents,
  Events,
  MessagingStatus
} from '@MerchantConfigurator/constants';
import { ApplicationContext } from '@MerchantConfigurator/context';
import EligibleView from '@MerchantConfigurator/components/messaging/EligibleView';
import ErrorView from '@MerchantConfigurator/components/messaging/ErrorView';

const Messaging = () => {
  const {
    isUpstreamMessagingEligible,
    locale = DefaultLocale,
    unhandledError
  } = useContext(ApplicationContext);

  if (unhandledError) {
    return <ErrorView />;
  }

  const status = isUpstreamMessagingEligible
    ? MessagingStatus.eligible
    : MessagingStatus.ineligible;

  switch (status) {
    case MessagingStatus.eligible:
      return <EligibleView />;
    case MessagingStatus.ineligible:
      return (
        <ErrorView
          description={ErrorContents[locale].inEligible}
          eventName={Events.ineligibleStateViewed}
          locale={locale}
        />
      );
    default:
      return <ErrorView locale={locale} />;
  }
};

export default Messaging;
